import ClinicSearchFormItem from './components/NewportClinicSearchFormItem';
import ClinicInlineShow from './components/NewportClinicInlineShow';
import ClinicShippingAddress from './components/NewportClinicShippingAddress';
import ClinicBillingAddress from './components/NewportClinicBillingAddress';

export const NewportClinicSearchFormItem = ClinicSearchFormItem;
export const NewportClinicInlineShow = ClinicInlineShow;
export const NewportClinicShippingAddress = ClinicShippingAddress;
export const NewportClinicBillingAddress = ClinicBillingAddress;
